import React, { Component } from "react";
import { connect } from "react-redux";
import PopUp from "../../Generic/PopUpDialog/PopUp";
import { customerFields } from "../fields";
import { API } from "aws-amplify";
import { setRefresh } from "../../../actions/algoliaActions";
import { withRouter } from "react-router";
import { setLoaderState, setAlgoliaLoaderState } from "../../../actions/loaderActions";

class DeleteCustomer extends Component {
  get fields() {
    let fields = JSON.parse(JSON.stringify(customerFields)); // Making a deep copy
    const details = { ...this.props.details };
    for (let i = 0; i < fields.length; i++) {
      fields[i].value = details[fields[i].id];
    }

    return fields;
  }

  APIMethod = async () => {
    try {
      this.props.dispatch(setAlgoliaLoaderState(true));
      await API.del("telishadeAPI", `/customer/${this.props.id}`);
      this.props.dispatch(setRefresh(true));
      this.props.dispatch(setLoaderState(false));
      this.props.history.replace("/customers/");
    } catch (error) {
      throw error;
    } finally {
      setTimeout(() => {
        this.props.dispatch(setRefresh(false));
        this.props.dispatch(setRefresh(true));
        this.props.dispatch(setRefresh(false));
        this.props.dispatch(setAlgoliaLoaderState(false));
      }, 0);
    }
  };

  render() {
    return (
      <PopUp
        header="Delete Customer?"
        body={`Are you sure you want to delete ${this.props.details.name}?`}
        button="Delete"
        buttoncolour="red"
        button2="cancel"
        buttonClickHandler={this.APIMethod}
        button2ClickHandler={undefined}
      />
    );
  }
}
const mapStateToProps = state => state.customers.customer;
export default withRouter(connect(mapStateToProps)(DeleteCustomer));
